import { render, staticRenderFns } from "./OperaLabelsZhuanquWindow.vue?vue&type=template&id=0b05d4d0&scoped=true&"
import script from "./OperaLabelsZhuanquWindow.vue?vue&type=script&lang=js&"
export * from "./OperaLabelsZhuanquWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaLabelsZhuanquWindow.vue?vue&type=style&index=0&id=0b05d4d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b05d4d0",
  null
  
)

export default component.exports